// extracted by mini-css-extract-plugin
module.exports = {"title":"PaymentDetail_title__2mx-K","warningMessageContainer":"PaymentDetail_warningMessageContainer__3mxqI"};